module.exports = __webpack_public_path__ + "media/bellring.c31bb14a.mp3";